export default __webpack_public_path__ + "static/media/discord.02658fc9.svg";